import React from 'react';

import { getImageData } from '../../../utils/contentful';

import { ImageWrapper, StyledImage } from './ImageAsset.styles';
import { AssetProps } from '../shared';

export function ImageAsset({ asset, rounded }: AssetProps) {
  return (
    <ImageWrapper>
      <StyledImage
        {...getImageData(asset)}
        rounded={rounded}
        data-blockid="assetWith5050Text-image"
      />
    </ImageWrapper>
  );
}
